<template>
  <div class="layout">
    <div class="navbar navbar-expand-lg bg-dark">
      <router-link class="alert-link navbar-brand" to="/">W&S Docs</router-link>
      <button aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
              data-target="#navbarNav" data-toggle="collapse" style="outline:  none" type="button">
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <router-link class="alert-link nav-link" to="/">Главная</router-link>
          <li class="btn-group">
            <router-link class="alert-link nav-link" to="/methods">Methods</router-link>
            <a aria-expanded="false" aria-haspopup="true" class="alert-link nav-link dropdown-toggle dropdown-toggle-split"
               data-toggle="dropdown" href="#" type="button">
              <span class="sr-only"></span>
            </a>
            <ul class="dropdown-menu bg-dark">
              <li :key="index" v-for="(theme, index) in themes">
                <router-link :to="'/methods/' + theme.theme_link" class="dropdown-item">{{ theme.theme_title }}
                </router-link>
              </li>
            </ul>
          </li>
          <router-link class="alert-link nav-link" to="/">FAQ</router-link>
          <router-link class="alert-link nav-link" to="/admin" v-if="AdminAuthStatusGet">AdminPanel</router-link>
        </ul>
      </div>
    </div>

    <main class="app-content">
      <div class="content-bg p-3 m-2">
        <router-view></router-view>
      </div>
    </main>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "MainLayout",
    data() {
      return {
        themes: [],
        loading: true,
        adminAuth: false
      }
    },
    computed: mapGetters(['AdminAuthStatusGet']),
    mounted() {

    },
  }
</script>

<style scoped>

</style>
